import * as React from "react";
import {
  Show,
  SimpleShowLayout,
  Datagrid,
  TextField,
  useTranslate,
  FunctionField,
  ArrayField,
  BooleanField,
} from "react-admin";
import moment from "moment-timezone";
import {
  DateField,
  Title,
  ShowOnlyTopToolbar,
} from "../../../shared/components/index.js";

const ShowClient = () => {
  const t = useTranslate();

  return (
    <Show title={<Title source="phone" />} actions={<ShowOnlyTopToolbar />}>
      <SimpleShowLayout>
        <TextField source="phone" />
        <TextField source="email" />
        <TextField source="first_name" />
        <TextField source="middle_name" />
        <TextField source="last_name" />
        <FunctionField
          source="sex"
          label="resources.Client.fields.sex.name"
          render={(record) =>
            record.sex && t(`resources.Client.fields.sex.${record.sex}`)
          }
        />
        <FunctionField
          source="date_of_birth"
          render={(record) => {
            if (!record.date_of_birth) {
              return "";
            } else {
              return (
                record &&
                moment.unix(record.date_of_birth / 1000).format("DD-MM-YYYY")
              );
            }
          }}
          label="resources.Client.fields.date_of_birth"
        />
        <BooleanField
          source="terms_agreement_confirm"
          sx={{
            "& .RaBooleanField-trueIcon": {
              color: "green",
            },
            "& .RaBooleanField-falseIcon": {
              color: "red",
            },
          }}
        />
        <FunctionField
          source="status"
          render={(record) =>
            t(`resources.Client.source.status.${record.status}`)
          }
        />

        <ArrayField
          source="unconfirmed_changes"
          label="resources.Client.fields.unconfirmed_changes.name"
        >
          <Datagrid optimized bulkActionButtons={null}>
            <TextField
              source="field_name"
              label="resources.Client.fields.unconfirmed_changes.field_name"
            />
            <TextField
              source="value"
              label="resources.Client.fields.unconfirmed_changes.value"
            />
            <FunctionField
              source="status"
              render={(record) =>
                t(`resources.Client.source.changes_status.${record.status}`)
              }
            />
          </Datagrid>
        </ArrayField>
        <FunctionField
          source="deleted_at"
          render={(record) => {
            if (record && record.deleted_at) {
              return <DateField source="deleted_at" />;
            } else {
              return t("");
            }
          }}
          label="resources.Client.source.deleted"
        />
        <FunctionField
          source="blocked_at"
          render={(record) => {
            if (record && record.blocked_at) {
              return <DateField source="blocked_at" />;
            } else {
              return t("");
            }
          }}
          label="resources.Client.source.blocked_at"
        />
        <DateField source="created_at" />
        <DateField source="updated_at" />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowClient;
